import { apiService } from './api';
import {
  LabComboMapping,
  CreateLabComboMappingRequest,
  UpdateLabComboMappingRequest,
} from '../types/analysisCombo';

function unwrapResponse<T>(response: { success: boolean; data: T; message?: string }, fallbackError: string): T {
  if (!response.success || response.data === null || response.data === undefined) {
    throw new Error(response.message || fallbackError);
  }
  return response.data;
}

class LabComboMappingService {
  async getMappings(labId: number): Promise<LabComboMapping[]> {
    const response = await apiService.get<LabComboMapping[]>(`/labs/${labId}/combo-mappings`);
    return unwrapResponse(response, 'Failed to fetch combo mappings');
  }

  async createMapping(labId: number, data: CreateLabComboMappingRequest): Promise<LabComboMapping> {
    const response = await apiService.post<LabComboMapping>(`/labs/${labId}/combo-mappings`, data);
    return unwrapResponse(response, 'Failed to create combo mapping');
  }

  async updateMapping(labId: number, id: number, data: UpdateLabComboMappingRequest): Promise<LabComboMapping> {
    const response = await apiService.put<LabComboMapping>(`/labs/${labId}/combo-mappings/${id}`, data);
    return unwrapResponse(response, 'Failed to update combo mapping');
  }

  async deleteMapping(labId: number, id: number): Promise<void> {
    const response = await apiService.delete<object>(`/labs/${labId}/combo-mappings/${id}`);
    if (!response.success) {
      throw new Error(response.message || 'Failed to delete combo mapping');
    }
  }
}

export const labComboMappingService = new LabComboMappingService();
